import React, { useState, useEffect } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import PrevQuestionLink from '../prevQuestionLink/prevQuestionLink';
import { regexByPhoneNumber, regexByEmail } from '../../../utils/RegexHelper';
import ErrorMsg from '../error/ErrorMsg';
import InfoIcon from '../../../assets/images/info.svg';
import closeIcon from '../../../../src/assets/images/close-Icon.svg';

const Question4 = props => {
  const [disableNextBtn, setDisableNextBtn] = useState(false);

  const setPhoneNumbers = (value, index) => {
    const contactNumbers = [...props.contactNumber];
    contactNumbers[index] = value;
    props.setContactNumber(contactNumbers);
  };

  const addContactNumber = () => {
    const contactNumbers = [...props.contactNumber];
    contactNumbers.push('');
    props.setContactNumber(contactNumbers);

    const errors = [...props.phoneErrors];
    errors.push(true);
    props.setPhoneErrors(errors);
  };

  const validatePhoneNumber = (value, index) => {
    const isValid = value === '' ? true : !regexByPhoneNumber(value);
    const phoneError = [...props.phoneErrors];
    phoneError[index] = isValid;
    props.setPhoneErrors(phoneError);
  };

  const deleteContactNumber = index => {
    const contactNumbers = [...props.contactNumber];
    contactNumbers.splice(index, 1);
    props.setContactNumber(contactNumbers);

    const errors = [...props.phoneErrors];
    errors.splice(index, 1);
    props.setPhoneErrors(errors);
  };

  // email
  const setEmailAddress = (value, index) => {
    const emails = [...props.deceasedEmailAddress];
    emails[index] = value;
    props.setDeceasedEmailAddress(emails);
  };

  const addEmail = () => {
    const emails = [...props.deceasedEmailAddress];
    emails.push('');
    props.setDeceasedEmailAddress(emails);

    const errors = [...props.deceasedEmailErrors];
    errors.push(true);
    props.setDeceasedEmailErrors(errors);
  };

  const validateEmail = (value, index) => {
    const isValid = !regexByEmail(value);
    const emailError = [...props.deceasedEmailErrors];
    emailError[index] = isValid;
    props.setDeceasedEmailErrors(emailError);
  };

  const deleteEmail = index => {
    const emails = [...props.deceasedEmailAddress];
    emails.splice(index, 1);
    props.setDeceasedEmailAddress(emails);

    const errors = [...props.deceasedEmailErrors];
    errors.splice(index, 1);
    props.setDeceasedEmailErrors(errors);
  };

  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <PrevQuestionLink setCurrentQuestion={props.setCurrentQuestion} prevQuestionIndex={3} />
        <h3 className={`${styles.pageTitle}`}> What was this person’s contact information?</h3>
        <p className={styles.questionText}>
          <img src={InfoIcon} className={styles.infoIcon} alt="info icon" />
          This information will help organisations locate any accounts the person held. If you don't
          know, leave the fields blank.
        </p>
        {/* email */}
        <div className={``}>
          <div className={`col-lg-7 col-md-10 row d-block ${styles.mobileRow}`}>
            <h4 className={styles.nswFormLabel}>Email address</h4>

            {props.deceasedEmailAddress.map((email, index) => (
              <div className={`position-relative ${styles.mobWidth95}`}>
                <input
                  type="text"
                  id={'deceasedEmailAddress'}
                  name={'deceasedEmailAddress'}
                  className={`nsw-form-input ${styles.nswFormInput}`}
                  value={email}
                  onChange={event => {
                    validateEmail(event.target.value, index);
                    setEmailAddress(event.target.value, index);
                  }}
                  aria-describedby={
                    props.deceasedEmailErrors[index] ? 'deceasedEmailErrorMessage' : undefined
                  }
                  aria-invalid={`${props.deceasedEmailErrors[index] === true ? 'false' : 'true'}`}
                />
                {props.deceasedEmailAddress.length > 1 ? (
                  <img
                    src={closeIcon}
                    alt="delete icon"
                    className={`${styles.deletePhone}`}
                    onClick={() => deleteEmail(index)}
                  />
                ) : null}

                {props.deceasedEmailErrors[index] === false ? (
                  <div className={`row`}>
                    <div className={`col-12 ${styles.errorContainer2}`}>
                      <ErrorMsg
                        id={'deceasedCEmailErrorMessage'}
                        type={'error'}
                        description={'The email address is invalid.'}
                      />
                    </div>
                  </div>
                ) : null}

                {props.deceasedEmailAddress.length < 5 &&
                props.deceasedEmailAddress.length === index + 1 &&
                props.deceasedEmailErrors[props.deceasedEmailErrors.length - 1] === true &&
                props.deceasedEmailAddress[props.deceasedEmailAddress.length - 1] != '' ? (
                  <div
                    className={`${styles.addAnotherLabel} flex ${styles.mtn15} mb-5 `}
                    onClick={() => addEmail()}
                  >
                    {' '}
                    <span>+ Add</span>
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
        {/* phone */}
        <div className={``}>
          <div className={`col-lg-7 col-md-10 row d-block ${styles.mobileRow}`}>
            <h4 className={styles.nswFormLabel}>Phone number</h4>

            {props.contactNumber.map((phoneNumber, index) => (
              <div className={`position-relative ${styles.mobWidth95}`}>
                <input
                  type="text"
                  inputmode="decimal"
                  id={'deceasedContactNumber'}
                  name={'deceasedContactNumber'}
                  className={`nsw-form-input ${styles.nswFormInput}`}
                  maxLength={'20'}
                  value={phoneNumber}
                  onChange={event => {
                    validatePhoneNumber(event.target.value, index);
                    setPhoneNumbers(event.target.value, index);
                  }}
                  aria-describedby={
                    props.phoneErrors[index] ? 'deceasedContactNumberErrorMessage' : undefined
                  }
                  aria-invalid={`${props.phoneErrors[index] === true ? 'false' : 'true'}`}
                />
                {props.contactNumber.length > 1 ? (
                  <img
                    src={closeIcon}
                    alt="delete icon"
                    className={`${styles.deletePhone}`}
                    onClick={() => deleteContactNumber(index)}
                  />
                ) : null}

                {props.phoneErrors[index] === false ? (
                  <div className={`row`}>
                    <div className={`col-12 ${styles.errorContainer2}`}>
                      <ErrorMsg
                        id={'deceasedContactNumberErrorMessage'}
                        type={'error'}
                        description={'The contact number is invalid.'}
                      />
                    </div>
                  </div>
                ) : null}

                {props.contactNumber.length < 5 &&
                props.contactNumber.length === index + 1 &&
                props.phoneErrors[props.phoneErrors.length - 1] === true &&
                props.contactNumber[props.contactNumber.length - 1] != '' ? (
                  <div
                    className={`${styles.addAnotherLabel} flex ${styles.mtn15}`}
                    onClick={() => addContactNumber()}
                  >
                    {' '}
                    <span>+ Add</span>
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.btnWrap}>
          <Button
            disabled={
              props.phoneErrors.includes(false) || props.deceasedEmailErrors.includes(false)
            }
            onClick={() => {
              props.saveDeceasedInfo();
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question4;
